import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import de from './translations/de.json';
import en from './translations/en.json';
import nl from './translations/nl.json';

import customSurveyDe from './translations/customsurvey/de.json';
import customSurveyEn from './translations/customsurvey/en.json';
import customSurveyNl from './translations/customsurvey/nl.json';
import customSurveyFr from './translations/customsurvey/fr.json';
import customSurveyIt from './translations/customsurvey/it.json';
import customSurveyPl from './translations/customsurvey/pl.json';
import customSurveyCs from './translations/customsurvey/cs.json';
import customSurveyEs from './translations/customsurvey/es.json';
import customSurveyDa from './translations/customsurvey/da.json';
import customSurveyLb from './translations/customsurvey/lb.json';
import customSurveyRu from './translations/customsurvey/ru.json';
import customSurveyRo from './translations/customsurvey/ro.json';
import customSurveyHr from './translations/customsurvey/hr.json';
import customSurveySr from './translations/customsurvey/sr.json';
import customSurveySl from './translations/customsurvey/sl.json';
import customSurveyUk from './translations/customsurvey/uk.json';

const resources = {
  de: {
    translation: de,
    customSurvey: customSurveyDe,
  },
  en: {
    translation: en,
    customSurvey: customSurveyEn,
  },
  nl: {
    translation: nl,
    customSurvey: customSurveyNl,
  },

  fr: { customSurvey: customSurveyFr },
  it: { customSurvey: customSurveyIt },
  pl: { customSurvey: customSurveyPl },
  cs: { customSurvey: customSurveyCs },
  es: { customSurvey: customSurveyEs },
  da: { customSurvey: customSurveyDa },
  lb: { customSurvey: customSurveyLb },
  ru: { customSurvey: customSurveyRu },
  ro: { customSurvey: customSurveyRo },
  hr: { customSurvey: customSurveyHr },
  sr: { customSurvey: customSurveySr },
  sl: { customSurvey: customSurveySl },
  uk: { customSurvey: customSurveyUk },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    returnEmptyString: false,
    detection: {
      // order and from where user language should be detected
      order: ['querystring', 'localStorage'],

      // keys or params to lookup language from
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'lang',

      // cache user language on
      caches: ['localStorage'],
    },
  })
  .catch((error) => console.error(error));

document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
